export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10529.9335dc1f.jpg";